import { FluentBundle } from '@fluent/bundle';

function makeBundle(locale, ftl) {
  const bundle = new FluentBundle(locale, { useIsolating: false });
  bundle.addMessages(ftl);
  return bundle;
}

export async function getTranslator(locale) {
  const bundles = [];
  const { default: en } = await import('../public/locales/en-US/send.ftl');
  if (locale !== 'en-US') {
    try {
      const { default: ftl } = await import(
        `../public/locales/${locale}/send.ftl`
      );
      bundles.push(makeBundle(locale, ftl));
    } catch (err) {
      console.warn(
        `No translation found for ${locale}, falling back to en-US.`
      );
    }
  }

  bundles.push(makeBundle('en-US', en));
  return (id, data) => {
    for (let b of bundles) {
      if (b.hasMessage(id)) {
        return b.format(b.getMessage(id), data);
      }
    }
  };
}
